// Data-only file — Pages SEO locales OVA Motors Parts (Guadeloupe).
// Règles éditoriales : aucune promesse de stock, sourcing à la demande (Guadeloupe puis Europe),
// contenu unique et utile par page, un seul H1, H2/H3 structurés, FAQ pour le schema FAQPage.

export const SEO_PAGES = [
  {
    slug: "moteurs-occasion-guadeloupe",
    label: "Moteurs d'occasion",
    title: "Moteur d'Occasion en Guadeloupe | OVA Motors Parts",
    description:
      "Moteur d'occasion en Guadeloupe : OVA Motors Parts vend des moteurs disponibles et source votre moteur essence ou diesel via son réseau local et européen.",
    keywords:
      "moteur occasion Guadeloupe, moteur d'occasion Guadeloupe, moteur complet Guadeloupe, moteur essence diesel occasion, code moteur Guadeloupe",
    h1: "Moteurs d'occasion en Guadeloupe",
    hero: "Votre moteur est hors service ? Nous recherchons le bloc compatible avec votre véhicule — en Guadeloupe d'abord, en Europe ensuite.",
    lead: "OVA Motors Parts vend des moteurs et pièces automobiles disponibles et réalise également du sourcing à la demande : lorsqu'une référence n'est pas disponible immédiatement, nous la recherchons auprès de notre réseau de fournisseurs en Guadeloupe, puis en Europe. Chaque moteur est identifié par ses références et contrôlé avant d'être proposé.",
    heroPhoto: {
      src: "/images/moteurs/moteur-sous-capot-1600.webp",
      srcSet: "/images/moteurs/moteur-sous-capot-800.webp 800w, /images/moteurs/moteur-sous-capot-1600.webp 1600w",
      width: 1600,
      height: 738,
      alt: "Moteur essence vu sous le capot : admission et bobines d'allumage — véhicule traité par OVA Motors Parts en Guadeloupe",
      caption: "Exemple de moteur traité ou sourcé par OVA Motors Parts en Guadeloupe.",
    },
    sections: [
      {
        h: "Trouver un moteur d'occasion en Guadeloupe : pas si simple",
        p: "En Guadeloupe, le parc de véhicules est limité et les moteurs disponibles localement partent vite. Les commandes de pièces neuves importées sont longues et coûteuses. Résultat : un moteur HS immobilise souvent un véhicule pendant des semaines. Notre métier est de réduire ce délai en activant simultanément la recherche locale et européenne.",
      },
      {
        h: "Comment nous sourçons votre moteur",
        img: {
          src: "/images/moteurs/moteur-palette-1200.webp",
          srcSet: "/images/moteurs/moteur-palette-600.webp 600w, /images/moteurs/moteur-palette-1200.webp 1200w",
          width: 1200,
          height: 790,
          alt: "Moteur complet d'occasion posé sur palette — exemple de moteur traité ou sourcé par OVA Motors Parts en Guadeloupe",
          caption: "Exemple de moteur traité ou sourcé par OVA Motors Parts en Guadeloupe.",
        },
        subs: [
          { t: "Recherche locale d'abord", p: "Nous interrogeons en priorité notre réseau en Guadeloupe : c'est la solution la plus rapide quand le moteur est disponible sur place." },
          { t: "Réseau européen ensuite", p: "Si la pièce n'est pas trouvée localement, nous élargissons la recherche à nos fournisseurs partenaires en Europe, en croisant les références constructeur." },
          { t: "Contrôle avant proposition", p: "Nous vérifions les informations disponibles auprès du fournisseur — référence, kilométrage annoncé, état annoncé et conditions de garantie — avant de vous présenter une proposition." },
        ],
      },
      {
        h: "La recherche par code moteur : la méthode la plus fiable",
        p: "Le code moteur (par exemple DV6, K9K, EB2, N47) est gravé sur le bloc ou indiqué sur l'étiquette moteur. Il permet d'identifier exactement la version compatible avec votre véhicule, là où la simple mention « 1.6 HDI » ou « 1.5 dCi » peut recouvrir plusieurs variantes incompatibles. Vous pouvez aussi nous communiquer votre plaque d'immatriculation ou le VIN : nous retrouvons le code moteur pour vous.",
      },
      {
        h: "Essence, diesel, complet ou semi-complet",
        p: "Selon votre besoin et votre budget, nous pouvons rechercher un moteur complet avec ses périphériques (injection, démarreur, alternateur), un moteur semi-complet ou un bloc nu. Précisez votre attente dans la demande : nous vous proposons la configuration la plus pertinente trouvée.",
      },
    ],
    engineCodes: {
      h: "Recherche par code moteur et motorisation",
      img: {
        src: "/images/moteurs/moteur-marque-900.webp",
        srcSet: "/images/moteurs/moteur-marque-450.webp 450w, /images/moteurs/moteur-marque-900.webp 900w",
        width: 900,
        height: 929,
        alt: "Moteur d'occasion identifié et marqué d'un numéro de suivi avant proposition — OVA Motors Parts, Guadeloupe",
        caption: "Chaque moteur est identifié par ses références avant de vous être proposé.",
      },
      intro:
        "Nous construisons progressivement des pages dédiées par code moteur et par motorisation pour faciliter vos recherches. Exemples de codes moteurs recherchés :",
      items: [
        { code: "1.2 PureTech (famille EB2)", vehicles: "Peugeot 208 / 2008 / 308, Citroën C3 / C4, DS3, Opel…", href: "/moteur-puretech-guadeloupe" },
        { code: "HN01", vehicles: "Variante 1.2 PureTech — Peugeot, Citroën, DS", href: null },
        { code: "HNZ", vehicles: "1.2 VTi / PureTech 82 — Peugeot 208, Citroën C3", href: null },
        { code: "HNY", vehicles: "Variante 1.2 PureTech — Peugeot, Citroën, DS", href: null },
      ],
      note: "Votre code moteur n'est pas listé ? Ce n'est pas bloquant : envoyez-nous votre demande avec votre plaque ou votre VIN, nous l'identifions pour vous.",
    },
    faq: [
      {
        q: "Livrez-vous dans toute la Guadeloupe ?",
        a: "Les modalités de remise ou d'expédition sont définies au moment du devis selon la pièce et la destination.",
      },
      {
        q: "Combien de temps pour obtenir un moteur ?",
        a: "Nous revenons vers vous après vérification des disponibilités. Le délai dépend ensuite de la pièce : plus court si le moteur est disponible ou trouvé en Guadeloupe, plus long s'il doit être sourcé en Europe. Nous vous indiquons le délai estimé dans la proposition.",
      },
      {
        q: "Avez-vous des moteurs en stock ?",
        a: "Certaines références peuvent être disponibles immédiatement. Lorsqu'un moteur n'est pas disponible, OVA Motors Parts lance une recherche auprès de son réseau en Guadeloupe puis en Europe afin de trouver une référence compatible avec votre véhicule. Contactez-nous avec votre immatriculation, VIN ou code moteur pour vérifier les disponibilités.",
      },
      {
        q: "Comment connaître mon code moteur ?",
        a: "Le code moteur figure généralement sur une étiquette ou gravé sur le bloc moteur, et peut être retrouvé à partir du numéro de série (VIN) de votre véhicule. Envoyez-nous votre plaque d'immatriculation ou votre carte grise en photo : nous nous chargeons de l'identification.",
      },
    ],
    related: ["moteur-puretech-guadeloupe", "boites-vitesses-guadeloupe", "calculateurs-auto-guadeloupe", "pieces-auto-occasion-guadeloupe", "moteurs"],
    serviceName: "Recherche et sourcing de moteurs d'occasion en Guadeloupe",
  },
  {
    slug: "boites-vitesses-guadeloupe",
    label: "Boîtes de vitesses",
    title: "Boîte de Vitesses d'Occasion en Guadeloupe | OVA Motors Parts",
    description:
      "Boîte de vitesses d'occasion en Guadeloupe : manuelle, automatique ou robotisée. OVA Motors Parts la source via son réseau local et européen. Devis sous 24 h.",
    keywords:
      "boîte de vitesses occasion Guadeloupe, boîte automatique Guadeloupe, boîte manuelle occasion, boîte DSG EDC Guadeloupe, code boîte de vitesses",
    h1: "Boîtes de vitesses d'occasion en Guadeloupe",
    hero: "Manuelle, automatique ou robotisée : nous recherchons la boîte compatible avec votre véhicule, en Guadeloupe puis en Europe.",
    lead: "Une boîte de vitesses qui craque, bloque ou passe en mode dégradé immobilise immédiatement votre véhicule. OVA Motors Parts source des boîtes de vitesses d'occasion — manuelles, automatiques, robotisées — identifiées par code boîte et références croisées, sans prétendre à du stock : chaque recherche est lancée à la demande.",
    sections: [
      {
        h: "Boîte manuelle ou automatique : une recherche par référence",
        p: "Une même motorisation peut être associée à plusieurs boîtes différentes. C'est pourquoi nous travaillons au code boîte (gravé sur le carter ou sur l'étiquette) et aux références constructeur, jamais « au modèle ». C'est la seule méthode qui garantit la compatibilité mécanique et électronique.",
      },
      {
        h: "Boîtes automatiques : le nerf de la guerre en Guadeloupe",
        p: "Les boîtes automatiques (classiques, robotisées, double embrayage type DSG/EDC) sont parmi les pièces les plus demandées — et les plus difficiles à trouver en Guadeloupe. La chaleur et les trajets urbains sollicitent fortement ces transmissions. Nous élargissons systématiquement la recherche à notre réseau européen pour les références introuvables localement.",
      },
      {
        h: "Ce que nous vérifions avant de vous proposer une boîte",
        subs: [
          { t: "Compatibilité", p: "Croisement du code boîte avec votre motorisation et votre année de mise en circulation." },
          { t: "Kilométrage et origine", p: "Kilométrage annoncé par le fournisseur et provenance du véhicule donneur, lorsque l'information est disponible." },
          { t: "État visuel", p: "Contrôle des points sensibles : carter, capteurs, convertisseur ou mécatronique selon le type de boîte." },
        ],
      },
      {
        h: "Comment formuler votre demande",
        p: "Indiquez la marque, le modèle, l'année, la motorisation et le type de boîte (manuelle ou automatique). Si vous avez accès au code boîte, joignez-le : la recherche sera nettement plus rapide. Une photo de l'étiquette de la boîte actuelle suffit. Réponse sous 24 h par WhatsApp ou par email.",
      },
    ],
    faq: [
      {
        q: "Trouvez-vous des boîtes automatiques récentes ?",
        a: "Oui, nous recherchons aussi bien des boîtes anciennes que des transmissions récentes (automatiques classiques, robotisées, double embrayage). La disponibilité dépend du réseau au moment de la demande : nous vous présentons les options trouvées, avec délai et prix, sans engagement.",
      },
      {
        q: "Quelle est la différence entre le code boîte et la référence ?",
        a: "Le code boîte identifie le type de transmission (par exemple 20DP05, MA5, TF-70), tandis que la référence constructeur identifie la pièce précise. Nous utilisons les deux pour croiser la compatibilité avec votre véhicule.",
      },
      {
        q: "La boîte est-elle vendue avec garantie ?",
        a: "Les modalités de garantie dépendent de la pièce et du fournisseur : elles sont indiquées clairement dans la proposition que nous vous envoyons, avant toute décision de votre part.",
      },
    ],
    related: ["moteurs-occasion-guadeloupe", "calculateurs-auto-guadeloupe", "pieces-auto-occasion-guadeloupe", "boites-de-vitesses"],
    serviceName: "Recherche et sourcing de boîtes de vitesses d'occasion en Guadeloupe",
  },
  {
    slug: "pieces-auto-occasion-guadeloupe",
    label: "Pièces auto d'occasion",
    title: "Pièces Auto d'Occasion en Guadeloupe | OVA Motors Parts",
    description:
      "Pièces auto d'occasion en Guadeloupe : OVA Motors Parts recherche et source toutes pièces automobiles — moteurs, boîtes, électronique, carrosserie. Devis sous 24 h.",
    keywords:
      "pièces auto occasion Guadeloupe, pièces détachées Guadeloupe, pièces automobiles d'occasion, casse auto Guadeloupe, sourcing pièces Guadeloupe",
    h1: "Pièces automobiles d'occasion en Guadeloupe",
    hero: "La pièce que vous cherchez n'est pas sur l'île ? Nous la recherchons pour vous, en Guadeloupe et en Europe.",
    lead: "OVA Motors Parts est un service de sourcing de pièces automobiles d'occasion basé en Guadeloupe. Notre spécialité : les pièces difficiles à trouver — moteurs, boîtes de vitesses, calculateurs, blocs ABS, turbos, pièces électroniques et carrosserie. Pas de catalogue figé, pas de stock fictif : chaque demande déclenche une recherche réelle auprès de notre réseau.",
    sections: [
      {
        h: "Pourquoi l'occasion sourcée est pertinente en Guadeloupe",
        p: "Sur une île, chaque pièce neuve importée subit des délais et des coûts logistiques importants. La pièce d'occasion contrôlée permet de réparer plus vite et à moindre coût — à condition d'identifier la bonne référence. C'est exactement notre travail : trouver la pièce compatible, vérifier sa référence et son état, puis organiser son acheminement jusqu'à vous ou votre garage.",
      },
      {
        h: "Ce que nous recherchons pour vous",
        subs: [
          { t: "Mécanique lourde", p: "Moteurs complets, boîtes de vitesses manuelles et automatiques, ponts, compresseurs de climatisation." },
          { t: "Électronique", p: "Calculateurs moteur (ECU), BSI, BSM, blocs ABS, modules, capteurs et faisceaux." },
          { t: "Injection et suralimentation", p: "Turbos, injecteurs, pompes à injection, débitmètres." },
          { t: "Carrosserie et habitacle", p: "Portières, capots, pare-chocs, optiques, rétroviseurs, commandes de lève-vitre et autres pièces d'habitacle." },
        ],
      },
      {
        h: "Comment fonctionne notre recherche",
        p: "Vous nous envoyez votre demande avec votre véhicule (plaque, carte grise ou photo de la pièce). Nous identifions la référence exacte, nous interrogeons notre réseau en Guadeloupe puis en Europe, nous comparons les options — prix, délai, état — et nous vous présentons une proposition claire. Vous décidez ensuite, sans engagement.",
      },
      {
        h: "Toutes marques, tous modèles",
        p: "Nous sourçons pour les marques les plus présentes en Guadeloupe — Peugeot, Citroën, Renault, Dacia, Toyota, Nissan, Hyundai, Kia, Volkswagen — comme pour les marques plus rares sur l'île. Plus votre demande est précise (référence, code moteur, photo), plus la recherche est rapide.",
      },
    ],
    faq: [
      {
        q: "Votre site affiche-t-il un stock de pièces ?",
        a: "Non. OVA Motors Parts fonctionne à la demande : nous ne prétendons pas détenir un stock. Chaque demande lance une recherche réelle auprès de notre réseau, et nous vous présentons uniquement les pièces effectivement trouvées.",
      },
      {
        q: "Quels sont les délais pour une pièce introuvable en Guadeloupe ?",
        a: "Si la pièce n'est pas disponible localement, nous la sourçons en Europe. Le délai dépend alors du fournisseur et du transport ; il vous est indiqué dans la proposition, avant toute validation.",
      },
      {
        q: "Comment se déroule le paiement ?",
        a: "Après validation de la proposition, les modalités de paiement et de livraison vous sont confirmées. Vous pouvez suivre votre demande directement par WhatsApp avec un interlocuteur humain.",
      },
      {
        q: "Puis-je envoyer simplement une photo de ma pièce ?",
        a: "Oui. Une photo de la pièce ou de son étiquette suffit pour lancer la recherche : nous nous chargeons de l'identification de la référence.",
      },
    ],
    related: ["moteurs-occasion-guadeloupe", "boites-vitesses-guadeloupe", "calculateurs-auto-guadeloupe", "blocs-abs-guadeloupe", "turbos-guadeloupe", "pieces-auto"],
    serviceName: "Recherche et sourcing de pièces automobiles d'occasion en Guadeloupe",
  },
  {
    slug: "moteur-puretech-guadeloupe",
    label: "Moteur 1.2 PureTech",
    title: "Moteur 1.2 PureTech en Guadeloupe | OVA Motors Parts",
    description:
      "Moteur 1.2 PureTech en Guadeloupe (Peugeot, Citroën, DS) : courroie dans l'huile, casse moteur — OVA source un bloc compatible, codes HNZ, HNY, HN01. Devis 24 h.",
    keywords:
      "moteur PureTech Guadeloupe, 1.2 PureTech occasion, moteur EB2 occasion, courroie PureTech, moteur Peugeot 208 Guadeloupe, moteur Citroën C3 Guadeloupe, HNZ HNY HN01",
    h1: "Moteur 1.2 PureTech en Guadeloupe",
    hero: "Courroie usée, moteur HS ? Nous recherchons un 1.2 PureTech compatible avec votre Peugeot, Citroën, DS ou Opel.",
    lead: "Le 1.2 PureTech équipe des millions de Peugeot, Citroën, DS et Opel — et il est l'un des moteurs les plus demandés en remplacement. OVA Motors Parts source des moteurs PureTech d'occasion identifiés par code moteur (famille EB2 : HNZ, HNY, HN01 et variantes), en Guadeloupe d'abord, en Europe ensuite.",
    sections: [
      {
        h: "Le 1.2 PureTech : un moteur très présent en Guadeloupe",
        p: "Présent sur les Peugeot 208, 2008 et 308, les Citroën C3, C4 et Berlingo, les DS3 et DS4 ou encore certains Opel, le trois-cylindres 1.2 PureTech (famille EB2) équipe une grande partie du parc récent en Guadeloupe. Il en résulte une demande forte en remplacement, alors que l'offre locale de blocs disponibles reste limitée.",
      },
      {
        h: "La courroie de distribution dans l'huile : le point faible connu",
        p: "Sur les premières générations du 1.2 PureTech, la courroie de distribution baigne dans l'huile moteur. Avec l'usure, ses particules peuvent se dégrader et circuler dans le circuit de lubrification, jusqu'à provoquer dans les cas graves une casse moteur. C'est la première cause de recherche d'un moteur PureTech de remplacement. Si votre voyant de pression d'huile s'allume ou si la courroie paraît gonflée, faites vérifier le véhicule rapidement par votre garagiste.",
      },
      {
        h: "Codes moteur de la famille PureTech : HNZ, HNY, HN01…",
        p: "La famille EB2 se décline en plusieurs codes moteur — HNZ (1.2 VTi 82), HNY, HN01 et d'autres variantes du PureTech. Deux moteurs « 1.2 PureTech » ne sont pas forcément interchangeables : la recherche se fait impérativement au code moteur et à la référence constructeur, que nous croisons avec votre véhicule avant toute proposition.",
      },
      {
        h: "Comment nous recherchons votre PureTech",
        p: "Envoyez-nous votre plaque d'immatriculation, votre carte grise ou une photo de l'étiquette moteur. Nous identifions le code exact, interrogeons notre réseau en Guadeloupe puis en Europe, et vérifions la compatibilité avant de vous présenter une proposition avec délai et prix. Vous restez libre de valider ou non.",
      },
    ],
    faq: [
      {
        q: "Ma courroie de PureTech est cassée : moteur forcément mort ?",
        a: "Pas toujours, mais souvent les dégâts sont importants (soupapes, segmentation). Votre garagiste confirme le diagnostic ; si le remplacement est nécessaire, envoyez-nous votre demande avec la plaque ou le VIN et nous recherchons un bloc compatible.",
      },
      {
        q: "Quelle différence entre HNZ, HNY et HN01 ?",
        a: "Ce sont des codes moteur de la même famille EB2 / 1.2 PureTech, correspondant à des versions et des niveaux d'équipement différents. Ils ne sont pas interchangeables tels quels : nous vérifions systématiquement la compatibilité avec votre véhicule avant de proposer un moteur.",
      },
      {
        q: "Le moteur proposé est-il testé ?",
        a: "Nous vérifions la référence, le kilométrage annoncé et l'état du moteur auprès du fournisseur avant proposition. Les modalités de garantie applicables vous sont précisées dans la proposition, selon la pièce et le fournisseur.",
      },
    ],
    related: ["moteurs-occasion-guadeloupe", "pieces-auto-occasion-guadeloupe", "calculateurs-auto-guadeloupe", "moteurs"],
    serviceName: "Recherche et sourcing de moteurs 1.2 PureTech en Guadeloupe",
  },
  {
    slug: "calculateurs-auto-guadeloupe",
    label: "Calculateurs auto",
    title: "Calculateur Auto en Guadeloupe | ECU, BSI – OVA Motors Parts",
    description:
      "Calculateur automobile en Guadeloupe : ECU moteur, BSI, BSM, calculateur ABS. OVA Motors Parts source votre référence exacte, réseau local et européen. Devis 24 h.",
    keywords:
      "calculateur auto Guadeloupe, calculateur moteur Guadeloupe, ECU occasion Guadeloupe, BSI BSM occasion, calculateur ABS Guadeloupe, électronique auto Guadeloupe",
    h1: "Calculateurs automobiles en Guadeloupe",
    hero: "ECU, BSI, BSM, calculateur ABS ou airbag : nous recherchons la référence exacte de votre calculateur.",
    lead: "Les pannes électroniques sont de plus en plus fréquentes, et le climat guadeloupéen — chaleur, humidité, air salin — n'épargne ni les calculateurs ni les connecteurs. OVA Motors Parts source des calculateurs automobiles d'occasion identifiés par référence gravée, croisée avec votre véhicule avant proposition.",
    sections: [
      {
        h: "Pourquoi les calculateurs lâchent-ils souvent en Guadeloupe ?",
        p: "L'humidité et la salinité de l'air attaquent les connectiques et les cartes électroniques, surtout sur les véhicules qui dorment dehors ou roulent peu. Corrosion des broches, condensation dans les boîtiers : les pannes électroniques sont un classique local — et les références précises se font rares sur l'île.",
      },
      {
        h: "Les calculateurs que nous sourçons",
        subs: [
          { t: "Calculateur moteur (ECU)", p: "Gestion injection et allumage. Recherche à la référence fabricant (Bosch EDC16/EDC17, Continental/Siemens SID, Delphi…) et à la référence constructeur." },
          { t: "BSI / BSM", p: "Boîtier de servitude intelligent et boîtier moteur : les centraux électriques des Peugeot, Citroën et Renault notamment." },
          { t: "ABS / ESP", p: "Calculateurs de bloc ABS et correcteurs électroniques de trajectoire." },
          { t: "Airbag et confort", p: "Calculateurs d'airbag, modules confort, modules d'éclairage, démarreurs mains libres." },
        ],
      },
      {
        h: "La règle d'or : la référence gravée",
        p: "Un calculateur ne se choisit pas « au modèle » : il se choisit à la référence gravée sur son étiquette. C'est l'unique garantie de compatibilité matérielle. Envoyez-nous une photo de l'étiquette de votre calculateur actuel — même partiellement lisible — et nous nous chargeons du croisement.",
      },
      {
        h: "Ce que nous ne faisons pas (transparence)",
        p: "OVA Motors Parts fournit la pièce, pas le codage : nous ne proposons ni programmation, ni clonage, ni reprogrammation. Sur beaucoup de véhicules récents, le calculateur de remplacement devra être codé ou appairé par votre garagiste. Nous vous le signalons dès la proposition quand c'est le cas.",
      },
    ],
    faq: [
      {
        q: "Un calculateur d'occasion peut-il être monté directement ?",
        a: "Cela dépend du véhicule : certains calculateurs sont vierges ou reconfigurables, d'autres sont verrouillés (antidémarrage) et nécessitent un codage ou un appairage par un professionnel. Nous vous indiquons ce point dans la proposition lorsque l'information est connue.",
      },
      {
        q: "Comment trouver la référence de mon calculateur ?",
        a: "Elle figure sur l'étiquette collée ou gravée sur le boîtier (par exemple une référence Bosch en 0 261 …, ou une référence constructeur). Le plus simple : débranchez le boîtier, photographiez l'étiquette et envoyez-nous la photo par WhatsApp.",
      },
      {
        q: "Pouvez-vous trouver un calculateur introuvable en Guadeloupe ?",
        a: "C'est notre spécialité. Si la référence n'est pas disponible localement, nous activons notre réseau européen de fournisseurs et nous vous présentons les options avec prix et délai.",
      },
    ],
    related: ["blocs-abs-guadeloupe", "moteurs-occasion-guadeloupe", "pieces-auto-occasion-guadeloupe", "calculateurs", "pieces-electroniques"],
    serviceName: "Recherche et sourcing de calculateurs automobiles en Guadeloupe",
  },
  {
    slug: "blocs-abs-guadeloupe",
    label: "Blocs ABS",
    title: "Bloc ABS en Guadeloupe | Pompe & Calculateur – OVA Motors Parts",
    description:
      "Bloc ABS en Guadeloupe : pompe ABS, calculateur ABS, groupe hydraulique d'occasion. OVA Motors Parts source votre référence (ATE, Bosch…). Devis sous 24 h.",
    keywords:
      "bloc ABS Guadeloupe, pompe ABS occasion, calculateur ABS Guadeloupe, groupe hydraulique ABS, bloc ATE Bosch Guadeloupe",
    h1: "Blocs ABS en Guadeloupe",
    hero: "Voyant ABS allumé, bloc hydraulique HS ? Nous recherchons le bloc ABS correspondant à votre véhicule.",
    lead: "Le bloc ABS — pompe hydraulique et calculateur associés — est une pièce de sécurité devenue difficile à trouver, et les références sont nombreuses pour un même modèle. OVA Motors Parts source des blocs ABS d'occasion identifiés par leur référence exacte, via son réseau en Guadeloupe puis en Europe.",
    sections: [
      {
        h: "Un élément de sécurité à ne pas négliger",
        p: "Le bloc ABS intervient à chaque freinage d'urgence pour éviter le blocage des roues. Voyant ABS ou ESP allumé, pédale dure, freinage qui « gicle » : ces symptômes imposent un diagnostic rapide. Sur les routes de Guadeloupe — descentes, virages, chaussées humides — rouler sans ABS fonctionnel n'est pas anodin.",
      },
      {
        h: "Bloc complet, pompe seule ou calculateur seul",
        p: "Selon la panne, il n'est pas toujours nécessaire de remplacer l'ensemble : la défaillance peut venir du calculateur (partie électronique) ou de la pompe (partie hydraulique). Nous sourçons le bloc complet comme les éléments séparés, en fonction de votre diagnostic et de la référence.",
      },
      {
        h: "La référence avant tout",
        p: "Les références ABS se lisent sur l'étiquette du bloc : fabricant (ATE, Bosch, Continental…), numéro de type (par exemple 10.0212-….) et référence constructeur. Une photo de l'étiquette nous suffit pour lancer le croisement avec votre véhicule.",
      },
      {
        h: "Montage et purge",
        p: "Le remplacement d'un bloc ABS impose une purge du circuit de freinage, parfois assistée par valise diagnostic, et dans certains cas un codage du calculateur. Ces opérations sont réalisées par votre garagiste : OVA fournit la pièce identifiée et vérifiée, nous vous le précisons dans la proposition.",
      },
    ],
    faq: [
      {
        q: "Comment savoir si mon bloc ABS est mort ?",
        a: "Voyant ABS/ESP permanent, défaut de communication avec le calculateur au diagnostic, fuite sur le groupe hydraulique ou pédale anormale sont les signes classiques. Seul un diagnostic chez un professionnel confirme l'origine ; demandez-lui la référence du bloc, puis envoyez-la-nous.",
      },
      {
        q: "Puis-je remplacer uniquement le calculateur de mon ABS ?",
        a: "Souvent oui, si la partie hydraulique est saine et si la référence correspond exactement. Précisez dans votre demande si vous cherchez le bloc complet, la pompe ou le calculateur seul.",
      },
      {
        q: "Les blocs ABS sont-ils chers à l'import en Guadeloupe ?",
        a: "En neuf, les prix importés sont souvent très élevés. L'occasion sourcée et contrôlée est généralement nettement plus accessible : nous vous présentons le prix et le délai dans la proposition, sans engagement.",
      },
    ],
    related: ["calculateurs-auto-guadeloupe", "pieces-auto-occasion-guadeloupe", "moteurs-occasion-guadeloupe", "blocs-abs"],
    serviceName: "Recherche et sourcing de blocs ABS d'occasion en Guadeloupe",
  },
  {
    slug: "turbos-guadeloupe",
    label: "Turbos",
    title: "Turbo d'Occasion en Guadeloupe | OVA Motors Parts",
    description:
      "Turbo d'occasion en Guadeloupe : Garrett, BorgWarner, IHI, Mitsubishi. OVA Motors Parts source le turbo compatible avec votre moteur, réseau local et européen. Devis 24 h.",
    keywords:
      "turbo occasion Guadeloupe, turbocompresseur Guadeloupe, turbo Garrett BorgWarner IHI, turbo diesel Guadeloupe, turbo pas cher Guadeloupe",
    h1: "Turbos automobiles en Guadeloupe",
    hero: "Sifflement, fumée, perte de puissance ? Nous recherchons le turbo compatible avec votre moteur.",
    lead: "Un turbo en fin de vie immobilise rarement immédiatement, mais il condamne le moteur à terme si la pièce n'est pas remplacée à temps. OVA Motors Parts source des turbocompresseurs d'occasion — Garrett, BorgWarner, IHI, Mitsubishi, Holset — identifiés par référence, en Guadeloupe puis en Europe.",
    sections: [
      {
        h: "Reconnaître un turbo en souffrance",
        p: "Sifflement aigu à l'accélération, perte de puissance, fumée bleue ou noire, consommation d'huile anormale : ces symptômes doivent alerter. En Guadeloupe, les trajets courts répétés et la chaleur favorisent l'encrassement des géométries variables et l'usure prématurée des paliers.",
      },
      {
        h: "La recherche par référence turbo",
        p: "Chaque turbo porte une référence fabricant (plaquette sur le corps du turbo) et une référence constructeur. C'est ce double croisement qui garantit la compatibilité avec votre moteur — deux turbos d'apparence identique peuvent avoir des calibrations différentes. Envoyez-nous une photo de la plaquette ou votre plaque d'immatriculation.",
      },
      {
        h: "Turbo seul ou avec ses périphériques",
        p: "Selon votre besoin, nous pouvons rechercher le turbo nu (chra et carters) ou accompagné de ses périphériques (wastegate, géométrie variable, durites). Nous vous conseillons également de prévoir avec votre garagiste le remplacement des joints et la vérification du circuit d'huile au montage.",
      },
      {
        h: "Injection associée : injecteurs et pompes",
        p: "Une panne de turbo s'accompagne parfois de problèmes d'injection. Nous sourçons également injecteurs, pompes à injection et débitmètres : une seule demande peut couvrir plusieurs pièces, avec une proposition consolidée.",
      },
    ],
    faq: [
      {
        q: "Un turbo d'occasion, est-ce fiable ?",
        a: "Tout dépend du contrôle. Nous vérifions la référence, l'origine et l'état (jeu d'axe, carters, géométrie) auprès du fournisseur avant de vous proposer la pièce. Les modalités de garantie vous sont indiquées dans la proposition, selon la pièce et le fournisseur.",
      },
      {
        q: "Pourquoi mon garagiste recommande-t-il de vérifier le circuit d'huile ?",
        a: "Un turbo est lubrifié par l'huile moteur : une huile dégradée ou une arrivée d'huile encrassée détruit rapidement le turbo neuf ou d'occasion. C'est une précaution standard à chaque remplacement.",
      },
      {
        q: "Quel délai pour un turbo introuvable en Guadeloupe ?",
        a: "Nous répondons sous 24 h avec un premier retour. Si le turbo n'est pas disponible localement, la recherche s'étend à l'Europe et le délai estimé vous est communiqué dans la proposition avant toute validation.",
      },
    ],
    related: ["moteurs-occasion-guadeloupe", "pieces-auto-occasion-guadeloupe", "calculateurs-auto-guadeloupe", "pieces-auto"],
    serviceName: "Recherche et sourcing de turbos d'occasion en Guadeloupe",
  },
];

export const SEO_BY_SLUG = Object.fromEntries(SEO_PAGES.map((p) => [p.slug, p]));

export const SEO_LABEL = {
  "moteurs-occasion-guadeloupe": "Moteurs d'occasion",
  "boites-vitesses-guadeloupe": "Boîtes de vitesses",
  "pieces-auto-occasion-guadeloupe": "Pièces auto d'occasion",
  "moteur-puretech-guadeloupe": "Moteur 1.2 PureTech",
  "calculateurs-auto-guadeloupe": "Calculateurs auto",
  "blocs-abs-guadeloupe": "Blocs ABS",
  "turbos-guadeloupe": "Turbos",
};
